
import { Dispatch } from "react";
import jwtAxios from "../../utils/jwtAxios";
import { AppActions } from "../../types/AppActions";
import { fetchError, showMessage } from "./Common";
import { GET_QUEUES, GET_REPORT_HISTORY, SET_REPORT_VIEW_TYPE } from "../../types/actions/Moderation.actions";

/*
  This is currently just an action hub, none of the endpoints persist their results.
  Therefore there is no associated reducer for these actions, yet.
 */

/** 
 * Deletes a specified Beacon permanently. This is not a "soft" delete, 
 * once you call this - that beacon is permanently GONE.
 * @param beaconId ref to the beacon that will be deleted.
 * @param callback returns action result as a boolean.
*/
export const RemoveBeacon = (beaconId: string, callback: (result: boolean) => void, reportId: string | undefined = undefined) => {

  // POST Data
  const postData = reportId ?
    {
      "beaconid": beaconId,
      "reportid": reportId
    } :
    {
      "beaconid": beaconId
    };

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.post('/api/admin/adminremovebeacon', postData)
      .then((data) => {
        if (data.status === 200) {
          // Deletion performed 
          dispatch(showMessage("The beacon has been deleted"));
          callback(true);
        } else {
          // Deletion Failed
          dispatch(fetchError("Request failed. Status:" + data.status));
          callback(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callback(false);
      });
  };
};

/** 
 * Ban a user, this implicitly DELETES all their created beacons.
 * Note that there is no API-based unban. User's must submit a support ticket to have their ban
 * appeals seen and reviewed. TEST THIS VERY CAREFULLY!
 * @param beaconId ID of the user to be banned.
 * @param callback returns action result as a boolean.
*/
export const BanUser = (userId: string, callback: (result: boolean) => void, reportId: string | undefined = undefined) => {

  // POST Data
  const postData = reportId ?
    {
      "userid": userId,
      "reportid": reportId
    }
    : {
      "userid": userId
    };

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.post('/api/admin/adminbanuser', postData)
      .then((data) => {
        if (data.status === 200) {
          // Deletion performed 
          dispatch(showMessage("The user has been banned"));
          callback(true);
        } else {
          // Deletion Failed
          dispatch(fetchError("Request failed. Status:" + data.status));
          callback(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callback(false);
      });
  };
};

/** 
 * Dismiss a report.
 * Note that there is no API-based undo.
 * @param reportId ID of the report to dismiss.
 * @param callback returns action result as a boolean.
*/
export const dismissReport = (reportId: string, callback: (result: boolean) => void) => {

  // POST Data
  const postData = {
    "reportid": reportId
  };

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.post('/api/admin/admindismissreport', postData)
      .then((data) => {
        if (data.status === 200) {
          dispatch(showMessage("The report has been dismissed"));
          callback(true);
        } else {
          // Deletion Failed
          dispatch(fetchError("Request failed. Status:" + data.status));
          callback(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callback(false);
      });
  };
};

export const getQueuedReports = (page: number, history: boolean, callBack: (result: boolean) => void) => {

  return (dispatch: Dispatch<AppActions>) => {
    jwtAxios.get('/api/report/reports', { params: { history: history, page: page } })
      .then((data) => {
        if (data.status === 200) {
          if (history) {
            dispatch({ type: GET_REPORT_HISTORY, payload: data.data });
          }
          else {
            dispatch({ type: GET_QUEUES, payload: data.data });
          }

          callBack(true);
        } else {
          dispatch(fetchError("Request failed. Status:" + data.status));
          callBack(false);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        callBack(false);
      });
  };
};

export const setReportViewType = (viewMode: string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({ type: SET_REPORT_VIEW_TYPE, payload: viewMode });
  };
};
